import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi } from '@shared/api/rest';
import type { TransferRequestGetFxRateRequest } from '@shared/api/rest/transferRequests/models';
import { ApiUtils } from '@shared/utils';
import { IQueryParams, RequestStrategyEnum } from '@shared/api/models';
import i18n from 'i18n';

const getFxRateEffect = createEffect((params: IQueryParams<TransferRequestGetFxRateRequest>) =>
  TransferRequestsApi.getFxRate(params.request, params.signal),
);
const clearEvent = createEvent();

const setRateEvent = createEvent<number>();

const $dataStore = createStore<number | null>(null)
  .on(getFxRateEffect.done, (_, data) => data.result.data ?? null)
  .on(setRateEvent, (_, value) => value)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getFxRateEffect.pending, (_, data) => data)
  .on(getFxRateEffect.fail, () => false)
  .on(getFxRateEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getFxRateEffect, () => null)
  .on(getFxRateEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}.`, data.error.message))
  .on(getFxRateEffect.done, () => null)
  .on(setRateEvent, () => null)
  .reset(clearEvent);

$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferRequestsGetFxRateStore = {
  events: {
    update: ApiUtils.wrapperApi(getFxRateEffect, RequestStrategyEnum.Debounce),
    setRate: setRateEvent,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
